import { COLORS } from "../../../utils/colors"


export const useHomeownerNotesStyles = () => {
    return {
        resetReport: {
            marginLeft: 'auto',
            textTransform: 'capitalize',
            textDecoration: 'underline',
            color: COLORS.RED,
            fontSize: '12px'
          },
          notesPanel: {
            padding: '1rem',
            overflowY: 'auto', 
            height: 'calc(100vh - 5.8rem)', 
            borderTop: `1px solid #ebebeb`,
            marginTop: '-1px',
            backgroundColor: 'white',
          },
    }
}